<!-- Hidden link für search engines to improve SEO -->
<a
  class="seo-link"
  tabindex="-1"
  [href]="'https://' + angebot.id"
  [routerLink]="['/']"
  queryParamsHandling="merge"
  [queryParams]="{ angebot: angebot.id }"
  [attr.aria-labelledby]="'angebot_' + angebot.id + '_heading'"
  aria-hidden="true"
></a>
<div class="d-flex align-items-center justify-content-between gap-2">
  <div class="now-card-tag">
    <span class="now-icon now-icon-calendar-blank"></span
    ><span class="now-card-tag-text">{{
      angebot.anzahlTermine | i18nPlural: anzahlTerminePlural
    }}</span>
  </div>
  @if (isNowWbSuche) {
    <now-wbsuche-lib-favorit-toggle [entity]="favoriteEntity"></now-wbsuche-lib-favorit-toggle>
  }
</div>
<h2
  class="now-heading heading"
  [attr.id]="'angebot_' + angebot.id + '_heading'"
  #heading
  tabindex="-1"
  nowWbsucheLibScrollToAndFocus
  [shouldScroll]="shouldScrollToAnchor"
  [shouldFocus]="shouldScrollToAnchor"
>
  <span [innerHTML]="breakTitle(angebot.titel)"></span>
  <span class="sr-only">Bildungsanbieter {{ angebot.bildungsanbieter.name }}</span>
</h2>
<div>
  <div class="fs-6 weiterbildungsart">
    <span class="sr-only">Weiterbildungsart</span
    ><span aria-hidden="true"><i class="now-icon now-icon-certificate"></i></span
    >{{ weiterbildungsart }}
  </div>
  <div class="row now-copytext">
    <div class="col-3 now-logo-column position-relative">
      <img
        [attr.id]="'angebot_' + angebot.id + '_logo'"
        class="now-image px-2"
        aria-hidden="true"
        [ngSrc]="anbieterLogo"
        fill
        alt="Logo des Anbieters"
        (error)="hasImgError = true"
      />
    </div>
    <div class="col-9">
      <p>
        <strong>Bildungsanbieter</strong><br />
        <span [attr.id]="'angebot_' + angebot.id + '_anbieter'">{{
          angebot.bildungsanbieter.name
        }}</span>
      </p>
    </div>
  </div>
  <p
    class="now-copytext mb-0"
    [hidden]="expanded || !inhaltText"
    [textContent]="inhaltText | truncate: 3"
  ></p>
  <div class="d-flex justify-content-center">
    <button
      type="button"
      class="now-btn now-btn-tertiary now-btn-icon inhalte-schalter"
      [hidden]="!inhaltText && angebot.anzahlTermine === 0"
      [ngClass]="expanded ? 'now-icon-caret-up-after' : 'now-icon-caret-down-after'"
      [attr.aria-expanded]="expanded"
      [attr.aria-controls]="'angebot_' + angebot.id + '_aufklappbereich'"
      [attr.aria-label]="(expanded ? 'weniger Inhalte: ' : 'mehr Inhalte: ') + angebot.titel"
      (click)="inhaltUmschalten()"
    >
      {{ expanded ? 'weniger Inhalte' : 'mehr Inhalte' }}
    </button>
  </div>
  <div [attr.id]="'angebot_' + angebot.id + '_aufklappbereich'" [hidden]="!expanded">
    <h3 class="h5">Weiterbildungsinhalte</h3>
    <div
      class="now-copytext anbieter_content"
      [attr.id]="'angebot_' + angebot.id + '_inhalte'"
      [innerHTML]="sanitizeFunction(angebot.inhalt)"
    ></div>
    @if (expanded) {
      <now-wbsuche-lib-termin-tabelle-kachel
        [angebot]="angebot"
        (terminSelected)="terminSelected.emit($event)"
      >
      </now-wbsuche-lib-termin-tabelle-kachel>
      <button
        [attr.id]="'focus_heading_btn_' + angebot.id"
        type="button"
        class="sr-only"
        aria-label="Zurück zum Angebotstitel"
        (click)="goToHeading()"
      ></button>
    }
  </div>
</div>
